// extracted by mini-css-extract-plugin
export default {"title":"cookie-consent-Accordion-title-9b6ae581","body":"cookie-consent-Accordion-body-73ed1d34","visible":"cookie-consent-Accordion-visible-a91bf716"};